"use strict";
/* globals module */
/**
 * @module companyClient
 * @description  Company Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var _1 = require("./");
var CompanyClient = /** @class */ (function () {
    function CompanyClient(companyBatchClient, companyRoute, apiClient) {
        this.companyBatchClient = companyBatchClient;
        this.companyRoute = companyRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CompanyClient.prototype, "routeDefinition", {
        get: function () {
            return this.companyRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyClient.prototype, "batch", {
        get: function () {
            return this.companyBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of company resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example companyClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CompanyClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the company resource.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @returns A promise that is resolved once the get action has been performed.
     * @param options Query resource options object.
     * @example companyClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CompanyClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.companyRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create company action has been performed; this action creates a new company resource.
     * @method
     * @param data A company object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create company action has been performed.
     * @example companyClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CompanyClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update company action has been performed; this action updates a company resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `companyRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(company);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A company object used to update specified company resource.
     * @returns A promise that is resolved once the update company action has been performed.
     * @example // company is a resource previously fetched using get action.
                    company.description = '<description>';
                    baasicCompanyService.update(company)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CompanyClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a company resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `companyRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(company);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data A company object used to delete specified company resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // company is a resource previously fetched using get action.
                    companyClient.remove(company)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                    });
     **/
    CompanyClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CompanyClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CompanyBatchClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CompanyBatchClient !== "undefined" && _1.CompanyBatchClient) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyRoute !== "undefined" && _1.CompanyRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CompanyClient);
    return CompanyClient;
}());
exports.CompanyClient = CompanyClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
